import { MODAL_FIRST_DISPATCH, TOGGLE_MODAL, SELECT_TYPE_FLIGHT } from "../shared/constants";

/**
 * Evento inicial (quando pega as airlines)
 *
 */

const initialState = {
	fired: false,
	isOpen: false,
	flightDirection: "RoundTrip"
};

export const modal = (state = initialState, action) => {
	switch (action.type) {
		case MODAL_FIRST_DISPATCH:
			return { ...state, fired: true };

		case TOGGLE_MODAL:
			return { ...state, isOpen: action.isOpen, fired: true };

		case SELECT_TYPE_FLIGHT:
			return { ...state, flightDirection: action.flightDirection };

		default:
			return state;
	}
};
